import { useTranslation } from 'react-i18next';
import Tabs from '../components/UI/Tabs';
import { CapacityAnalysisType } from '../enums/CapacityAnalysisType';
import CapacityAnalysis from './CapacityAnalysis';

export default function CapacityAnalysisTabs() {
    const { t } = useTranslation();
    const tabs = [
        {
            label: t('analysis.comparePlanPlan'),
            tabPanel: <CapacityAnalysis type={CapacityAnalysisType.CAPACITY_ANALYSIS} />,
        },
        {
            label: t('analysis.comparePlanActual'),
            tabPanel: <CapacityAnalysis type={CapacityAnalysisType.PERFORMED_CAPACITY_ANALYSIS} />,
        },
    ];

    return <Tabs tabs={tabs}></Tabs>;
}
